module.exports = __webpack_public_path__ + "img/taskapp.5001889d.png";